/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'
// redux
import { connect } from 'react-redux'
import { Card, Icon, Divider } from 'antd'
import image from '../../../resource/image/imgEventDefaul.jpg'

const seconds = new Date().getTime() / 1000
const { Meta } = Card

class ModalEvent extends React.Component {
    constructor(props) {
        super(props)
    }
    componentDidMount() {}

    render() {
        return (
            <div>
                {this.props.lstEvent.length === 0 && (
                    <div>Không có dữ liệu</div>
                )}
                {this.props.lstEvent.map(event => (
                    <a href={`/app/qbevents/${event.event_id}`}>
                        <Card
                            // title={
                            //     <div style={{ alignItems: 'center' }}>
                            //         <Icon
                            //             style={{
                            //                 fontSize: '20px',
                            //                 color: '#08c',
                            //                 paddingRight: 5,
                            //                 paddingBottom: 8,
                            //             }}
                            //             type="calendar"
                            //         />{' '}
                            //         {event.name}
                            //     </div>
                            // }
                            style={{ width: '100%', justifyContent: 'center' }}
                            cover={
                                <img
                                    alt="example"
                                    style={{ height: 250, padding: 10 }}
                                    src={
                                        event.avatar !== ''
                                            ? event.avatar
                                            : image
                                    }
                                />
                            }
                        >
                            <Meta
                                title={event.name}
                                description={event.content}
                            />
                            {/* <p>{event.content}</p> */}
                        </Card>
                        <Divider />
                    </a>
                ))}
            </div>
        )
    }
}

ModalEvent.propTypes = {
    classes: PropTypes.object,
}
const mapStateToProps = state => {
    return {
        userInfo: state.auth.userInfo,
        currentEvent: state.eventReducer.currentEvent,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalEvent)
